import React from "react";
import styled from "styled-components";

import LineSeedKrBd from "../../../../atoms/text/lineSeedKr/lineSeedKrBd";

const LSBdBody02 = (props) => {
  return <LSBdBody02Wrapper {...props} />;
};

export default LSBdBody02;

const LSBdBody02Wrapper = styled(LineSeedKrBd)`
  font-size: 15px;
  font-weight: 700;
  line-height: 21px;
  letter-spacing: -0.3px;

  color: #222222;
`;
